import { render, staticRenderFns } from "./DiseaseDetail.vue?vue&type=template&id=0d9c33cb&scoped=true&"
import script from "./DiseaseDetail.vue?vue&type=script&lang=ts&"
export * from "./DiseaseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DiseaseDetail.vue?vue&type=style&index=0&id=0d9c33cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9c33cb",
  null
  
)

export default component.exports